import React from "react";
import PropTypes from "prop-types";

class DateTr extends React.Component {
  render() {
    return (
      <tr>
        <th>{this.props.fieldName}</th>
        <td>
          {this.props.fieldValue ? (
            <span>
              {moment(this.props.fieldValue).format(this.props.fieldFormat)}
            </span>
          ) : (
            "-"
          )}
        </td>
      </tr>
    );
  }
}

DateTr.propTypes = {
  fieldName: PropTypes.string,
  fieldValue: PropTypes.string,
  fieldFormat: PropTypes.string
};

DateTr.defaultProps = {
  fieldFormat: "MM/DD/YYYY"
};

export default DateTr;
